import request from '@/util/request'

// 赛事小项列表（不分页）
export const getCompetitionItemList = (data) => {
  return request({
    url: `/api/register/competition/item/list`,
    method: 'GET',
    data
  })
}
